import { ApolloCache, Reference } from '@apollo/client'
import { CartTypeEnum } from '../../generated/gqlTypes'

interface MutatedCart {
  id: string
  type: CartTypeEnum
  linesByCategory?: unknown
}

// Cart mutations return the refreshed cart (see CartMutationResultFragment), which Apollo normalizes into
// the cache by itself. This handles the parts normalization can't: pointing `Query.cart` at the returned cart
// and dropping cart fields the mutation didn't return. Apollo refetches an evicted field only for queries that
// are currently mounted and read it, so pages that don't show it make no extra request.
export const syncCartCache = (cache: ApolloCache<unknown>, cart?: MutatedCart | null) => {
  if (!cart) {
    return
  }
  const cartId = cache.identify({ __typename: 'CartType', id: cart.id })
  // An anonymous shopper's first add creates the cart, while `Query.cart` still points at the unsaved placeholder.
  cache.modify({
    fields: {
      cart(existing: Reference, { storeFieldName, toReference }) {
        return storeFieldName.includes(`"${cart.type}"`) ? toReference(cartId) : existing
      },
    },
  })
  // depends on the cart total, which has just changed
  cache.evict({ id: cartId, fieldName: 'shippingDiscounts' })
  if (!('linesByCategory' in cart)) {
    cache.evict({ id: cartId, fieldName: 'linesByCategory' })
  }
}
